module.exports = __webpack_public_path__ + "img/banner_promo_sky_04.6cf10fa5.png";